export default "__VITE_ASSET__xzsqSTEo__"